<template>
  <v-dialog
    v-model="dialog"
    max-width="1100px"
    persistent
    :fullscreen="this.$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar
        dark
        style="background-color: black; color: black"
        class="elevation-0"
      >
        <v-toolbar-title
          ><h4 style="color: white">{{ formTitle }}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon
          @click="$emit('onClosed', false)"
          color="white"
          size="30"
          v-if="expand == true"
          >close</v-icon
        >
      </v-toolbar>
      <v-card flat style="height: 520px; overflow-y: auto" class="mx-3">
        <v-expand-x-transition>
          <v-card-text v-show="expand">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm5>
                  <h2 class="my-3">Add-on Details</h2>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-checkbox
                    label="Is this add-on required?"
                    v-model="form.is_required"
                    color="primary"
                  ></v-checkbox
                ></v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    :rules="[rules.required]"
                    label="Add-on name(TH)"
                    outline
                    v-model="form.adddon_th"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    :rules="[rules.required]"
                    label="Add-on name(EN)"
                    outline
                    v-model="form.adddon_en"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-radio-group
                    style="padding: 0px"
                    hide-details
                    v-model="select_store_type"
                    row
                    @change="selectType()"
                  >
                    <v-radio
                      label="All store"
                      color="gray"
                      :value="0"
                    ></v-radio>
                    <v-radio
                      label="Select Store"
                      color="gray"
                      :value="1"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm5>
                  <!-- <v-autocomplete
                    outline
                    :rules="[rules.required]"
                    v-model="form.province"
                    :items="province_list"
                    outlined
                    item-text="province_name_th"
                    item-value="province_id"
                    dense
                    label="Select province"
                  ></v-autocomplete> -->
                </v-flex>
                <v-flex xs12 v-if="select_store_type == 1">
                  <v-card
                    class="my-3"
                    flat
                    style="
                      border-radius: 7px;
                      border: 2px solid #e3e4ea;
                      padding: 5px;
                      background-color: #f8f8f8;
                    "
                  >
                    <v-layout wrap justify-center>
                      <v-flex xs2>
                        <div class="d-flex justify-center">
                          <div>
                            <v-btn
                              block
                              @click="slidePage()"
                              style="
                                width: 100%;
                                color: white;
                                border-radius: 7px;
                              "
                              color="black"
                            >
                              <v-icon>mdi-store</v-icon>
                              <h3>
                                {{
                                  form.select_store.length > 0
                                    ? "EDIT STORE "
                                    : "SELECT STORE"
                                }}
                              </h3>
                            </v-btn>
                            <p
                              style="
                                text-align: center;
                                font-size: 14px;
                                font-weight: 600;
                              "
                            >
                              Total store: {{ form.select_store.length }}
                            </p>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <!-- <v-divider class="my-3" thickness></v-divider> -->
                  <div
                    style="border-bottom: 1px dashed #00000029"
                    class="my-3"
                  ></div>
                </v-flex>
                <v-flex xs12>
                  <div>
                    <h2>Set Price</h2>
                  </div>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-radio-group v-model="select_type_price" row>
                    <v-radio label="Bath" color="gray" :value="1"></v-radio>
                    <v-radio
                      label="Percent"
                      color="gray"
                      :value="2"
                      class="ml-4"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    :rules="[
                      rules.required,
                      select_type_price == 2 ? rules.percent : rules.onlyNumber,
                    ]"
                    label="Amount"
                    outline
                    v-model="form.amount"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-select
                    :items="[
                      { name: 'Transport', id: 1 },
                      { name: 'Product', id: 2 },
                    ]"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                    label="Additional price with"
                    outline
                    v-model="form.price_type"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-expand-x-transition>
        <v-expand-x-transition>
          <v-card-text flat v-show="expand == false" style="height: 100%">
            <v-layout row wrap justify-space-between>
              <v-flex xs12 sm5>
                <div style="display: flex; justify-content: space-between">
                  <v-text-field
                    prepend-icon="search"
                    label="Search store name"
                    v-model="searchUnSelectStore"
                    class="pr-3"
                  ></v-text-field>
                  <v-btn
                    @click="selectAllStore()"
                    style="
                      background: #000000 0% 0% no-repeat padding-box;
                      box-shadow: 0px 3px 6px #00000029;
                      border-radius: 7px;
                      font-weight: bold;
                      letter-spacing: 0.1rem;
                    "
                    color="info"
                    >select all store</v-btn
                  >
                </div>
                <!-- <v-autocomplete
                  @input="select($event)"
                  outline
                  v-model="form.select_store"
                  style="height: 105px; overflow-y: auto; width: 100%"
                  prepend-inner-icon="store_mall_directory"
                  :items="autocompleteStore"
                  item-text="store_name_th"
                  item-value="store_id"
                  clearable
                  deletable-chips
                  label="Select store"
                  multiple
                  :loading="isLoading"
                  :rules="[rules.requiredStore, rules.alreadyStore]"
                >
                  <template v-slot:selection="data">
                    <div></div>
                  </template>
                </v-autocomplete> -->
                <v-data-table
                  :headers="UnselectedHeaders"
                  :items="filterUnSelectedStoreList"
                  class="elevation-0"
                >
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            font-size: 14px;
                          "
                        >
                          <span v-on="on">
                            {{ props.header.text }}
                          </span>
                        </div>
                      </template>
                      <span>
                        {{ props.header.text }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:items="props">
                    <tr style="border: 0px">
                      <td>
                        <div
                          class="my-1 pa-3"
                          style="
                            border-radius: 7;
                            border: 2px solid #757575;
                            display: flex;
                            justify-content: space-between;
                          "
                        >
                          <div>{{ props.item.store_name_th }}</div>
                          <v-icon
                            @click="
                              form.select_store.push(props.item.store_id);
                              select();
                            "
                            >mdi-arrow-right-circle</v-icon
                          >
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-divider
                :vertical="true"
                style="height: 450px"
                v-if="this.$vuetify.breakpoint.mdAndUp"
              ></v-divider>
              <v-flex xs12 sm5 class="pl-3">
                <div style="height: 500px; overflow-x: auto">
                  <div style="display: flex; justify-content: space-between">
                    <v-text-field
                      prepend-icon="search"
                      label="Search store name"
                      v-model="searchSelectedStore"
                      class="pr-3"
                    ></v-text-field>
                    <v-btn
                      @click="clearAllStore()"
                      style="
                        background: #000000 0% 0% no-repeat padding-box;
                        box-shadow: 0px 3px 6px #00000029;
                        border-radius: 7px;
                        font-weight: bold;
                        letter-spacing: 0.1rem;
                      "
                      color="error"
                      >clear all store</v-btn
                    >
                  </div>
                  <v-data-table
                    :headers="headers"
                    :items="filterSelectedStoreList"
                    class="elevation-0"
                  >
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 14px;
                            "
                          >
                            <span v-on="on">
                              {{ props.header.text }}
                            </span>

                            <span v-on="on" style="color: #a8a8a8">
                              (Total Store :{{ tableSelect.length }} )
                            </span>
                          </div>
                        </template>
                        <span>
                          {{ props.header.text }}
                        </span>
                      </v-tooltip>
                    </template>

                    <template v-slot:items="props">
                      <tr style="border: 0px">
                        <td>
                          <div
                            class="my-1 pa-3"
                            style="
                              border-radius: 7;
                              border: 2px solid #757575;
                              display: flex;
                              justify-content: space-between;
                            "
                          >
                            <div>{{ props.item.store_name_th }}</div>
                            <v-icon @click="deleteDataTable(props.item)"
                              >mdi-close-circle</v-icon
                            >
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
            </v-layout>
            <v-divider style="width: 100%"></v-divider>
          </v-card-text>
        </v-expand-x-transition>
      </v-card>
      <v-card-actions style="padding-bottom: 30px" class="mx-5">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <div
              style="display: flex"
              :style="{
                justifyContent: this.$vuetify.breakpoint.mdAndUp
                  ? 'start'
                  : 'center',
              }"
            >
              <v-btn
                v-if="expand == false"
                :loading="isAdding"
                dark
                color="black"
                style="
                  width: 120px;
                  background: #000000 0% 0% no-repeat padding-box;
                  box-shadow: 0px 3px 6px #00000029;
                  border-radius: 7px;
                  font-weight: bold;
                  letter-spacing: 0.1rem;
                  width: 167px;
                  height: 47px;
                "
                @click="BackForm()"
                >BACK</v-btn
              >
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div
              style="display: flex"
              :style="{
                justifyContent: this.$vuetify.breakpoint.mdAndUp
                  ? 'end'
                  : 'center',
                marginTop: this.$vuetify.breakpoint.mdAndUp ? '' : '10px',
              }"
            >
              <v-btn
                :disabled="expand == false ? form.select_store == 0 : null"
                :loading="isAdding"
                style="
                  width: 120px;
                  background: #ffd602;
                  box-shadow: 0px 3px 6px #00000029;
                  border-radius: 7px;
                  font-weight: bold;
                  letter-spacing: 0.1rem;
                  width: 167px;
                  height: 47px;
                "
                @click="expand == true ? CreateAddon() : AddSelect()"
                >Save</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["dialog", "editedIndex", "editForm"],
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
        requiredStore: (value) =>
          (!!value && value.store_id != 0) || "Required.",
        alreadyStore: (value) =>
          value.store_id != -1 || "Store already to select.",
        onlyNumber: (value) =>
          /^[0-9+.]*$/.test(value) || "only numbers are allowed.",
        percent: (value) =>
          (value <= 100 && value >= 0) || "More than 0 and Less than 100",
      },
      isLoading: false,
      select_store_type: 0,
      select_type_price: 1,
      isAdding: false,
      form: {},
      expand: true,
      pagination: {
        sortBy: "name",
      },
      selected: [],
      headers: [
        {
          text: "Selected store",
          align: "left",
          value: "name",
          sortable: false,
        },
      ],
      UnselectedHeaders: [
        {
          text: "Unselected store",
          align: "left",
          value: "name",
          sortable: false,
        },
      ],
      form: {
        adddon_th: "",
        adddon_en: "",
        province: null,
        amount: "",
        price_type: 1,
        select_store: [0],
        is_required: false,
      },
      tableSelect: [],
      select_store: [],
      searchUnSelectStore: "",
      searchSelectedStore: "",
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.expand = true;
        this.$refs.form.resetValidation();
        this.form.price_type = 1;
        if (
          this.editForm.add_on_stores.length > 0 &&
          this.editedIndex == 1 &&
          this.formTitle == "Edit Add-on"
        ) {
          this.select_type_price = this.editForm.add_on_price_type;
          this.select_store_type = 1;
          this.form.select_store = [...this.editForm.add_on_stores];
          this.form.adddon_th = this.editForm.add_on_name_th;
          this.form.adddon_en = this.editForm.add_on_name_en;
          this.form.province = this.editForm.add_on_province;
          this.form.amount = this.editForm.add_on_price;
          this.form.price_type = this.editForm.add_on_set_price_type;
          if (this.form.select_store[0] == 0) {
            this.select_store_type = 0;
            this.form.select_store = [0];
          }
          this.form.is_required = this.editForm.add_on_required;
        }
      } else {
        this.clear();
      }
    },
  },
  computed: {
    ...mapState({
      orderCountEachProvince: (state) =>
        state.fetchOrderListBack.orderCountEachProvince,
    }),
    ...mapGetters({
      isEditStaff: "isEditStaff",
      province_list: "fetchProvinceBack/provinceSplited",
      autocompleteStore: "fetchStoreBack/autocompleteStore",
    }),
    formTitle() {
      return this.editedIndex === 0 ? "New Add-on" : "Edit Add-on";
    },
    province() {
      return this.orderCountEachProvince.find((val) =>
        val.province_name_en
          .replace(/ /g, "")
          .toLowerCase()
          .includes(this.$route.params.province.toLowerCase())
      );
    },
    filterUnSelectedStoreList() {
      return this.autocompleteStore.filter(
        (val) =>
          this.form.select_store.includes(val.store_id) == false &&
          val.store_name_th
            .toLowerCase()
            .includes(this.searchUnSelectStore.toLowerCase())
      );
    },
    filterSelectedStoreList() {
      return this.tableSelect.filter((val) =>
        val.store_name_th
          .toLowerCase()
          .includes(this.searchSelectedStore.toLowerCase())
      );
    },
  },
  methods: {
    AddSelect() {
      this.expand = true;
    },
    BackForm() {
      this.expand = true;
      this.select_store_type = 0;
      this.form.select_store = [];
    },
    async deleteDataTable(item) {
      let index = this.tableSelect.findIndex(
        (element) => element.store_id == item.store_id
      );
      this.tableSelect.splice(index, 1);
      let index_select = this.form.select_store.findIndex(
        (element) => element == item.store_id
      );
      this.form.select_store.splice(index_select, 1);
    },
    async CreateAddon() {
      if (this.select_store_type == 0) {
        this.form.select_store = [0];
      }
      if (this.form.select_store.length == 0 && this.select_store_type == 1) {
        this.select_store_type = 0;
        this.form.select_store = [0];
      }
      let store = JSON.parse(JSON.stringify(this.form.select_store));
      if (this.$refs.form.validate()) {
        this.isAdding = true;
        let payload = {
          add_on_name_th: this.form.adddon_th,
          add_on_name_en: this.form.adddon_en,
          add_on_province: this.province.province_id,
          add_on_stores: store,
          add_on_price: this.form.amount,
          add_on_price_type: this.select_type_price,
          add_on_set_price_type: this.form.price_type,
          add_on_required: this.form.is_required,
        };
        this.$emit("onSaved", { payload: payload, formType: this.editedIndex });
        this.isAdding = false;
        this.$emit("onClosed", false);
      }
    },
    select() {
      let select = JSON.parse(JSON.stringify(this.form.select_store));
      let currentValue = select.slice(-1);
      if (this.tableSelect.some((val) => val.store_id == currentValue[0])) {
        this.tableSelect = [];
        for (let i = 0; i < select.length; i++) {
          let index = this.autocompleteStore.findIndex(
            (val) => val.store_id == select[i]
          );
          let obj = {
            store_id: this.autocompleteStore[index].store_id,
            store_name_th: this.autocompleteStore[index].store_name_th,
            store_partner: this.autocompleteStore[index].store_partner,
          };
          this.tableSelect.unshift(JSON.parse(JSON.stringify(obj)));
        }
        return;
      }
      if (this.form.select_store.length == 0) {
        this.tableSelect = [];
        return;
      }
      let table = this.autocompleteStore.find(
        (element) => element.store_id == currentValue[0]
      );
      this.tableSelect.unshift(JSON.parse(JSON.stringify(table)));
    },
    clear() {
      this.form = {
        adddon_th: "",
        adddon_en: "",
        province: "",
        select_store: "",
        price_type: 0,
        is_required: false,
      };
      this.select_store_type = 0;
      this.select_type_price = 1;
      this.$emit("onClosed", false);
    },
    selectType() {
      if (this.select_store_type == 0) {
        this.form.select_store = [0];
      } else if (this.select_store_type == 1) {
        this.form.select_store = [];
      }
    },
    async slidePage() {
      if (this.editedIndex == 0) {
        if (this.form.select_store.length == 0) {
          this.form.select_store = [];
          this.tableSelect = [];
          this.expand = false;
        } else {
          this.expand = false;
        }
      } else {
        this.tableSelect = [];
        for (let i = 0; i < this.form.select_store.length; i++) {
          let index = this.autocompleteStore.findIndex(
            (val) => val.store_id == this.form.select_store[i]
          );
          let obj = {
            store_id: this.autocompleteStore[index].store_id,
            store_name_th: this.autocompleteStore[index].store_name_th,
            store_partner: this.autocompleteStore[index].store_partner,
          };
          this.tableSelect.push(JSON.parse(JSON.stringify(obj)));
        }
        this.expand = false;
      }
    },
    selectAllStore() {
      this.tableSelect = this.autocompleteStore.map((val) => {
        return {
          store_id: val.store_id,
          store_name_th: val.store_name_th,
          store_partner: val.store_partner,
        };
      });
      this.form.select_store = this.tableSelect.map((val) => val.store_id);
    },
    clearAllStore() {
      this.tableSelect = [];
      this.form.select_store = [];
    },
  },
};
</script>

<style></style>
